export default __webpack_public_path__ + "static/salma-4968978d5403a375d3de36147a92acc4.jpg";